var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { RenderMainHeading } from "../RenderMainHeading";
import { RenderSubheading } from "../RenderSubheading";
import { CardType } from "../../../../../data";
var RenderFavorites = /** @class */ (function (_super) {
    __extends(RenderFavorites, _super);
    function RenderFavorites() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RenderFavorites.prototype.renderToggleOddsBtn = function (index) {
        return {
            shouldShow: index === 0 && this.props.state.isMiniEventCard,
            toggled: this.props.state.showOddBtns,
            tooltipMessage: this.props.state.tooltipMessage,
            onClick: this.props.state.toggleOddsBtnOnClick
        };
    };
    RenderFavorites.prototype.render = function () {
        var _this = this;
        var renderedSubheadings = 0;
        var headingId = this.props.state.sports[0];
        var config = this.props.state.options.dataProvider.cardConfiguration[headingId]
            || this.props.state.options.dataProvider.cardConfiguration[0];
        var mainHeading = {
            id: headingId,
            name: this.props.name,
            sportId: ""
        };
        return React.createElement(RenderMainHeading, { key: "favorites-section-" + mainHeading.id, id: "favorite-section-" + mainHeading.id, name: mainHeading.name, eventsCountLength: this.props.state.displayFavoriteEvents.length, cms: __assign({}, this.props.cms, { ShowLivePhraseBeforeSportName: false }), dict: {}, shouldCollapse: false, toggleOddsBtn: this.renderToggleOddsBtn(0), marketNames: [], marketTemplates: [], cardType: CardType.Regular, renderedHeadings: 0 }, this.props.state.displayFavoriteLeagues.map(function (league) {
            var events = _this.props.state.displayFavoriteEventsByLeague(league.id);
            var chunks = _this.props.state.getEventsHeight(events);
            return React.createElement(RenderSubheading, { key: "subheading-" + league.id, id: league.id, name: league.name, eventsCountLength: events.length, cms: _this.props.cms, marketNames: _this.props.getMarketNames(__assign({}, mainHeading, { sportId: league.sportId })), marketTemplates: [], renderedHeadings: renderedSubheadings++, cardType: config.cardType }, _this.props.getEvents(0, events, { id: headingId }, chunks, league));
        }));
    };
    return RenderFavorites;
}(React.Component));
export { RenderFavorites };
//# sourceMappingURL=RenderFavorites.js.map